import deburr from 'lodash/deburr'

export function getVCTextIdentifier(currencyName?: string): string {
  if (!currencyName) return ''

  // 1. deburr replaces non-latin characters with latin, e.g. ä -> a
  // 2. lowercase
  // 3. replace all characters which are not a letter, number or underscore with space
  // 4. trim
  // 5. replace spaces with underscrores
  // 7. replace repeated underscrores with one
  // 8. remove trailing underscore

  return deburr(currencyName)
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, ' ')
    .trim()
    .replace(/ /g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/_$/g, '')
}

export default getVCTextIdentifier
